import { render, staticRenderFns } from "./CustomCollapse.vue?vue&type=template&id=2f2900d6&scoped=true&"
import script from "./CustomCollapse.vue?vue&type=script&lang=js&"
export * from "./CustomCollapse.vue?vue&type=script&lang=js&"
import style0 from "./CustomCollapse.vue?vue&type=style&index=0&id=2f2900d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2900d6",
  null
  
)

export default component.exports